<kt-portlet class="edit-doctor-div">
  <kt-portlet-header
    [viewLoading$]="loading$"
    class="cards-inside-doctor-form card-head-lg card-head"
  >
    <ng-container ktPortletTitle>
      <span>{{ params.name | titlecase }}</span
      ><span> - {{ params.rlz === '1C1CHBD' ? 'Custom' : 'Knostos' }}</span>
    </ng-container>
    <ng-container ktPortletTools>
      <a
        ktBackButton
        class="btn btn-secondary mr-2"
        *ngIf="!entity_id"
        mat-raised-button
        matTooltip="Back to the clients list"
      >
        <i class="la la-arrow-left"></i>
        <span class="hidden-mobile" translate="GLOBAL.BACK">Back</span>
      </a>
    </ng-container>
  </kt-portlet-header>
  <mat-tab-group [(selectedIndex)]="selectedTab" class="cards-inside-doctor-form-tab">
    <mat-tab *ngIf="true">
      <ng-template mat-tab-label> Page Group </ng-template>
      <ng-template matTabContent>
        <div class="until-they">
          <kt-page-group-list></kt-page-group-list>
        </div>
      </ng-template>
    </mat-tab>
    <mat-tab *ngIf="params.rlz === '1C1CHBD'">
      <ng-template mat-tab-label> External Access </ng-template>
      <ng-template matTabContent>
        <div class="until-they">
          <kt-external-access-list></kt-external-access-list>
        </div>
      </ng-template>
    </mat-tab>
    <mat-tab *ngIf="true">
      <ng-template mat-tab-label> Internal Access </ng-template>
      <ng-template matTabContent>
        <div class="until-they">
          <kt-internal-access-list></kt-internal-access-list>
        </div>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</kt-portlet>
